import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rechtliches',
  templateUrl: './rechtliches.component.html',
  styleUrls: ['./rechtliches.component.css']
})
export class RechtlichesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
